import ServiceBase from './ServiceBase';

class CouponService extends ServiceBase {
  goToUsePage(item) {
    if (item.status != 0) {
      return;
    }
    if (item.dis_type == 1) {
      if (item.scope_type == 1) {
        this.vue.$router.push({
          name: 'Course',
        });
      } else {
        this.vue.$router.push({
          name: 'CourseCoupon',
          query: {
            id: item.id,
          },
        });
      }
    } else if (item.dis_type == 2) {
      if (item.scope_type == 1) {
        this.vue.$router.push({
          name: 'Goods',
        });
      } else {
        this.vue.$router.push({
          name: 'GoodsCoupon',
          query: {
            id: item.id,
          },
        });
      }
    } else if (item.dis_type == 5) {
      if (item.scope_type == 1) {
        this.vue.$router.push({
          name: 'Classes',
        });
      } else {
        this.vue.$router.push({
          name: 'ClassesCoupon',
          query: {
            id: item.id,
          },
        });
      }
    }
  }
}

export default () => {
  return new CouponService();
};
